export default __webpack_public_path__ + "static/media/selffix_white.2d277f5d.png";